import { FunctionalComponent, h } from "preact";
import style from "./style.css";

const PoweredByKorra: FunctionalComponent = () => {
    return (
        <div className={style.poweredByKorraWrapper}>
            <div className={style.poweredByKorra}>
                Powered by{" "}
                <a
                    className={style.topKorraA}
                    target="_blank"
                    href="https://korra.ai/"
                >
                    Korra
                    <img
                        style={{ verticalAlign: "middle" }}
                        height="14"
                        width="14"
                        src="/assets/icons/korra-logo.svg"
                    />
                </a>
            </div>
        </div>
    );
};

export default PoweredByKorra;
